<template>
  <div class="sso_container">
    <div class="container_lf">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="item in imgLists" :key="item">
          <img :src="item" alt="" class="imgs">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="container_rg">
      <div class="rg_logo">
        <img src="https://gas.mcd.com/API/adfs/portal/images/new/logo.png" alt="">
      </div>
      <div class="rg_content">
        <div class="content">
          <p class="welcome">欢迎,</p>
          <p class="tip">请在下面选择您的角色以开始使用:</p>
          <div class="role" @click="goPage(0)">
            <img src="../../assets/img/company.png" alt="">
            <p class="labor">公司员工</p>
            <!-- <p class="laborType">机组人员和机组培训师</p> -->
          </div>
          <div class="role" @click="goPage(1)">
            <img src="../../assets/img/restaurant.png" alt="">
            <p class="labor">餐厅员工</p>
            <!-- <p class="laborType">加盟商,加盟商办公室员工和餐厅经理</p> -->
          </div>
          <div class="role" @click="goPage(2)">
            <img src="../../assets/img/supplier1.png" alt="" style="margin-right:20px">
            <p class="labor">供应商</p>
            <!-- <p class="laborType">员工,顾问和供应商</p> -->
          </div>
          <!-- <p class="other_login_type">联合伙伴登录</p>
          <div class="bottom_tip">
            <p class="tip1">登录后,我同意 </p>
            <p class="tip2">安全须知</p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { userService } from "../../api/user-manage/user";
export default {
  name: '',
  data() {
    return {
      imgLists: [
        "https://gas.mcd.com/API/adfs/portal/images/mcd_login_1.png",
        "https://gas.mcd.com/API/adfs/portal/images/mcd_login_2.png",
        "https://gas.mcd.com/API/adfs/portal/images/mcd_login_3.png",
        "https://gas.mcd.com/API/adfs/portal/images/mcd_login_4.png"
      ],
      urlLists: []
    };
  },

  mounted() {
    var param = ''
    console.log("GY🚀 ~ file: ssoLogin.vue:62 ~ mounted ~ this.$route.query.target:", this.$route.query.target);
    if (this.$route.query.target) {
      param = encodeURIComponent(this.$route.query.target)
    }
    this.getLoginInfo(param)
  },

  methods: {
    getLoginInfo(param) {
      userService.getSSoLoginInfo(param).then(res => {
        console.log("GY🚀 ~ file: ssoLogin.vue:62 ~ userService.getSSoLoginInfo ~ res:", res);
        if (res.code == '200') {
          this.urlLists = res.data
        }
      });
    },
    goPage(index) {
      console.log('this.urlLists[index]', this.urlLists[index])
      // this.$router.push(this.urlLists[index])
      window.open(this.urlLists[index], "_self");
    }
  },
};
</script>
<style scoped>
</style>
